import { render } from "./Lots.vue?vue&type=template&id=d974e6b6"
import script from "./Lots.vue?vue&type=script&lang=js"
export * from "./Lots.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__